let config = {
  defaultContainerElement: null,
  defaultIconPack: 'mdi',
  defaultDialogConfirmText: null,
  defaultDialogCancelText: null,
  defaultSnackbarDuration: 3500,
  defaultToastDuration: 2000,
  defaultTooltipType: 'is-primary',
  defaultTooltipAnimated: false,
  defaultInputAutocomplete: 'on',
  defaultDateFormatter: null,
  defaultDateParser: null,
  defaultDayNames: null,
  defaultMonthNames: null,
  defaultFirstDayOfWeek: null,
  defaultUnselectableDaysOfWeek: null,
  defaultTimeFormatter: null,
  defaultTimeParser: null,
  defaultModalScroll: null,
  defaultDatepickerMobileNative: true,
  defaultTimepickerMobileNative: true,
  defaultNoticeQueue: true,
  defaultInputHasCounter: true
}

export default config

export const setOptions = (options) => { config = options }



// WEBPACK FOOTER //
// ./src/components/common/snackbar/config.js